import React, { useCallback, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
// TODO: (D.K.) Necessary make refactoring of this part of the functionality is needed (to get rid of react-redux)
// eslint-disable-next-line no-restricted-imports
import { useDispatch } from 'react-redux';
import { MobileWindowContent } from '@yme/atoms/modal-window/MobileWindowContent';
import { ModalWindowHeader } from '@yme/atoms/modal-window/ModalWindowHeader';
import { Overlay } from '@yme/atoms/overlay';
import { useLockBodyScroll, usePortalCreatorRoot } from '@yme/hooks/index';
import { setIsModalHide } from '@yme/modals/actions';
import { MODAL_BODY_MIN_HEIGHT, MODAL_WINDOW_CLASSNAME, SPA_ROOT_ID } from './constants';
import { ModalWindowWrapStyled } from './styled';
export function StaticModalWindow(props) {
    const dispatch = useDispatch();
    const onHideHandler = () => dispatch(setIsModalHide());
    const { title, onHide = onHideHandler, portalRoot, children, staticModalSize = undefined, isRightToLeft, isHideVisibility = false, minHeight = MODAL_BODY_MIN_HEIGHT, maxHeight, footerComponent, isClickOutsideDisabled = false, hasCloseButton = true, dataTestId, } = props;
    const portal = usePortalCreatorRoot(portalRoot);
    const ref = useRef(null);
    useLockBodyScroll();
    const handleOutsideClick = useCallback((event) => {
        const currentElem = ref?.current?.contains(event.target);
        // Define outside click
        if (ref?.current && !currentElem && !isClickOutsideDisabled) {
            event.preventDefault();
            onHide();
        }
    }, [isClickOutsideDisabled, onHide]);
    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick, true);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick, true);
        };
    }, [handleOutsideClick]);
    useEffect(() => {
        const spaRoot = document.getElementById(SPA_ROOT_ID);
        spaRoot?.classList.add(MODAL_WINDOW_CLASSNAME);
        return () => {
            spaRoot?.classList.remove(MODAL_WINDOW_CLASSNAME);
        };
    }, []);
    return ReactDOM.createPortal(React.createElement(Overlay, { isStatic: true },
        React.createElement(ModalWindowWrapStyled, { staticModalSize: staticModalSize, isHideVisibility: isHideVisibility, isRightToLeft: isRightToLeft, ref: ref, "data-testid": dataTestId },
            React.createElement(ModalWindowHeader, { isRightToLeft: isRightToLeft, hasCloseButton: hasCloseButton, title: title, onHide: onHide }),
            React.createElement(MobileWindowContent, { staticModalSize: staticModalSize, minHeight: minHeight, maxHeight: maxHeight }, children),
            footerComponent && footerComponent)), portal);
}
